module.exports = __webpack_public_path__ + "clothes.f008d0161e67cccf7ca2.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/clothes/webfont/clothes.svg
// module id = ../../../../../src/assets/fonts/line-icons-pro/clothes/webfont/clothes.svg
// module chunks = styles